import { CSS as MenuCSS } from '../../components/menu/menu.style';

export const CSS = {
	container: 'c-MoveCollections',
	isLoading: 'c-MoveCollections--IsLoading',
	content: 'c-MoveCollections__Content',
	jobContent: 'c-MoveCollectionsJob__Content',
	menu: 'c-MoveCollections__Menu',
};

export const Style = {
	[CSS.container]: {
		width: '600px',
	},
	[CSS.isLoading]: {
		display: 'flex',
		'justify-content': 'center',
	},
	[CSS.content]: {
		display: 'flex',
		'align-items': 'baseline',
		'justify-content': 'space-around',
	},
	[CSS.jobContent]: {
		display: 'flex',
		'align-items': 'start',
		'flex-direction': 'column',
	},
	[CSS.menu]: {
		width: '600px',
		position: 'absolute',
		[`& .${MenuCSS.menu}`]: {
			right: 'auto',
			width: '100%',
		},
	},
};
